import React from 'react';
import { Container, Typography, Grid, Box, Card, CardContent } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import VerifiedIcon from '@mui/icons-material/Verified';
import TimerIcon from '@mui/icons-material/Timer';
import HandymanIcon from '@mui/icons-material/Handyman';

const repairServices = [
  {
    icon: BuildIcon,
    title: 'Professional Repairs',
    description: 'Expert repair services for all types of devices with guaranteed quality workmanship.'
  },
  {
    icon: VerifiedIcon,
    title: 'Genuine Parts',
    description: 'We use only authentic, high-quality replacement parts to ensure optimal performance and longevity.'
  },
  {
    icon: TimerIcon,
    title: 'Quick Turnaround',
    description: 'Fast and efficient repair service without compromising on quality.'
  },
  {
    icon: HandymanIcon,
    title: 'Comprehensive Testing',
    description: 'Thorough testing and quality assurance before returning your device.'
  }
];

function QualityRepairs() {
  return (
    <Box sx={{ bgcolor: 'background.default', py: 8 }}>
      <Container>
        <Typography 
          variant="h2" 
          align="center" 
          gutterBottom
          className="gradient-text"
          sx={{ mb: 6 }}
        >
          Quality Repairs
        </Typography>
        <Typography 
          variant="h5" 
          align="center" 
          color="text.secondary" 
          sx={{ mb: 8, maxWidth: 800, mx: 'auto' }}
        >
          Professional repair services with quality guaranteed
        </Typography>

        <Grid container spacing={4}>
          {repairServices.map((service, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card 
                className="glass-effect"
                sx={{ 
                  height: '100%',
                  background: 'linear-gradient(135deg, rgba(124, 58, 237, 0.1) 0%, rgba(124, 58, 237, 0.2) 100%)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '15px',
                  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)'
                  }
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {React.createElement(service.icon, { 
                      sx: { 
                        fontSize: 40, 
                        color: 'primary.main',
                        mr: 2 
                      } 
                    })}
                    <Typography variant="h5" component="h3">
                      {service.title}
                    </Typography>
                  </Box>
                  <Typography variant="body1" color="text.secondary">
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom className="gradient-text">
            Our Quality Guarantee
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}>
            We stand behind our work with a comprehensive quality guarantee. Our certified technicians 
            use state-of-the-art tools and genuine parts to ensure your device receives the best possible care.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default QualityRepairs;
